import React, { useMemo } from 'react';

import { Icon, IconName, IconSize } from 'app/design-system/components/Icon';
import type { SupportedLang } from 'app/lang';
import type { Country } from 'app/modules/Layout/Header/LanguageSelector';
import { type ComponentsConfig, Control, Option } from 'app/widgets/Dropdown/Single';

import styles from './LanguageSelector.module.scss';

type FlagIconsName<T extends IconName = IconName> = T extends `flag-${string}` ? T : never;

const getIconName = (lang: SupportedLang): FlagIconsName => `flag-${lang}`;

function DropdownComponents(): ComponentsConfig<Country> {
  return useMemo(() => ({
    Option: (props) => (
      <Option {...props}
              customInnerProps={{
                ['data-ga-event']: 'header-langSelect',
                ['data-ga-event-value']: props.data.value,
              }}>
        <Icon icon={getIconName(props.data.value)}
              size={IconSize.DEFAULT}
              className={styles.menuItemIcon} />
        <span className={styles.menuItemLabel}>
          {props.children}
        </span>
      </Option>
    ),
    Control: (props) => {
      const data = props.getValue();
      const icon = Array.isArray(data) && 'value' in data[0] && getIconName(data[0].value);
      return (
        <Control {...props}
                 customInnerProps={{ ['data-ga-event']: 'header-langMenu' }}>
          {icon && (
            <Icon icon={icon}
                  size={IconSize.DEFAULT}
                  className={styles.controlIcon} />
          )}
          {props.children}
        </Control>
      );
    },
  }), []);
}

export default DropdownComponents;
